import React from 'react';
import { useNavigate } from 'react-router-dom';
import { userAppContext } from '../../context/Context';
import { useAcademicApplication } from '../../hooks/useAcademicApplication';
import { useCheckoutFlow } from '../../hooks/useCheckoutFlow';


function AdvancedPlanCard() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = userAppContext();
  const { redirectToCheckout } = useCheckoutFlow();
  const { canSeePrices: canSeePricesFromHook } = useAcademicApplication(user?.email, isAuthenticated);

  // Use tag-based logic from hook
  const canSeePrices = canSeePricesFromHook();

  const handleUpgradeClick = async () => {
    const priceId = process.env.REACT_APP_STRIPE_ADVANCED_PRICE_ID;
    await redirectToCheckout({
      title: 'Professional',
      priceId: priceId || '',
      quantity: 1,
    });
  };

  return (
    <div className="PricingCard-ac">
      <header>
        <p className="card-title">Advanced</p>
        <p className="card-price">API Access</p>
        {canSeePrices ? (
          <p className="card-price">1,999 EUR / year</p>
        ) : (
          <p className="card-price" style={{ opacity: 0.8 }}>
            Contact us for pricing
          </p>
        )}
      </header>
      <button className="btn-gradient-pink" onClick={handleUpgradeClick}>
        Upgrade
      </button>
      <button className="btn-gradient-pink" onClick={() => navigate('/plans')}>
        + info
      </button>
    </div>
  );
}

function AdvancedPlanOnly() {
  return (
    <div className="PricingApp">
      <div className="app-container">
        <div className="pricing-cards p-3 flex-row gap-4">
          <AdvancedPlanCard />
        </div>
      </div>
    </div>
  );
}

export default AdvancedPlanOnly;
